export default {
  sellerFlashSalesDiscount: {
    id: 'product_card_price_seller_flash_sales_discount',
    defaultMessage: 'Save {price}',
  },
} as const
